// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout___3dqqo","Content":"Content___147T1"};